module.exports = __webpack_public_path__ + "media/Children of the Corn.66f614ec.mp3";